module.exports = __webpack_public_path__ + "static/thunderC-d09b7d0ea9a5b4472b4dd1a35233f100.jpg";